import { createContext } from 'react';

/**
 * Признак «только для чтения» у контролов формы (замок, подсказка). false — режим просмотра карточки: там только
 * чтение — норма для каждого поля, и признак был бы шумом (как у таблиц в просмотре).
 */
export const ReadonlyIndicatorContext = createContext(true);
